import asyncActionTypes from './types';

export function chageTouchPointTypeCp(touchPoint) {
  return {
    type: asyncActionTypes.TOUCH_POINT_PROPERTY_CP,
    touchPoint,
  };
}